exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ready-for-inspection[data-v-1bca96c6] {\n    display: inline-block;\n    margin: 0 8px;\n}\n.ready-link[data-v-1bca96c6] {\n    color: #1a7e3a;\n    font-size: 18px;\n    text-decoration: none;\n}\n.ready-link[data-v-1bca96c6]:hover {\n    color: #14591b;\n}\n", ""]);

// exports
